import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { LoginType, UrsPageTypeEnum, URS_PAGE_TYPE_SEARCH_KEY } from '@yaotai/common-utils';
import { LoginRegisterType, MailRegisterType } from '../constants';

// 该hooks多次调用能获取正确query参数是通过直接修改query
export function useLoginType() {
  const [searchParams, setSearchParams] = useSearchParams();
  const [loginRegisterType, setLoginRegisterType] = useState<LoginRegisterType>(LoginType.Phone);

  const loginType = (searchParams.get('type') || LoginType.Phone) as LoginType;
  const isUrs = [LoginType.Phone, LoginType.NetEaseMail].includes(loginType as LoginType);
  const isMail = [LoginType.CommonMail, LoginType.NetEaseMail].includes(loginType as LoginType);

  const pageType = searchParams.get(URS_PAGE_TYPE_SEARCH_KEY);
  const isRegister = pageType === UrsPageTypeEnum.Register;

  const setLoginType = (type: LoginType) => {
    searchParams.delete('type');
    searchParams.delete(URS_PAGE_TYPE_SEARCH_KEY);
    searchParams.append('type', type);
    setSearchParams(searchParams);
  };

  useEffect(() => {
    if (isRegister && loginType === LoginType.NetEaseMail) {
      setLoginRegisterType(MailRegisterType.UrsMail);
    } else {
      setLoginRegisterType(loginType);
    }
  }, [loginType, pageType, isRegister]);

  return {
    loginType,
    setLoginType,
    isUrs,
    isMail,
    pageType,
    isRegister,
    loginRegisterType,
  };
}
